import { api2 , apiUpload } from './ApiService';

export default class CardService {
    
    static async get(){
        let response =  await api2.get(`/api/v1/card`)
        return response.data
    }


    static async search(key,page,perpage){
        let data ={
            key: key,
            page: page,
            perpage:perpage
        }
        let response =  await api2.post(`/api/v1/card/search`,data)
        return response.data
    }
 
    static async create(formData){
        let response = await apiUpload.post(`/api/v1/card/create`,formData)
        return response.data
    }
    static async update(formData){
        let response = await apiUpload.post(`/api/v1/card/update`,formData)
        return response.data
    }
    static async delete(data){
        let response = await api2.post(`/api/v1/card/delete`,data)
        return response.data
    }
    
}


// WEBPACK FOOTER //
// ./src/service/CardService.js